import React, { useCallback, useState } from 'react';

const FaceBookIcon = () => {
  const [isHovered, setIsHovered] = useState(false);

  const handleMouseEnter = useCallback(() => {
    setIsHovered(true);
  }, []);

  const handleMouseLeave = useCallback(() => {
    setIsHovered(false);
  }, []);

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      {isHovered ? (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="25" height="25" rx="6" fill="#0866FF" />
          <path
            d="M14.0465 23.4375V13.2801H16.82L17.1875 9.77975H14.0465L14.0512 8.02781C14.0512 7.11488 14.137 6.62571 15.434 6.62571H17.1679V3.125H14.394C11.0621 3.125 9.88938 4.82303 9.88938 7.67857V9.78015H7.8125V13.2805H9.88938V23.4375H14.0465Z"
            fill="#FEFEFE"
          />
        </svg>) : (
        <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect y="0.0571289" width="25" height="25" rx="6" fill="#FEFEFE" />
          <path
            d="M13.9818 23.3875V13.2765H16.7426L17.1085 9.79218H13.9818L13.9865 8.04825C13.9865 7.13948 14.0719 6.65255 15.363 6.65255H17.089V3.16785H14.3278C11.0111 3.16785 9.84375 4.85811 9.84375 7.7006V9.79257H7.77637V13.2769H9.84375V23.3875H13.9818Z"
            fill="#2B2A29"
          />
        </svg>)}
    </div>
  );
};

export default FaceBookIcon;